import React, {useEffect, useState} from "react";
import styles from './PasswordChange.module.scss';

import {useDispatch} from "react-redux";
import InputWithValidation from "../miscellaneous/InputWithValidation/InputWithValidation";
import {$t} from "../../helpers/translator";
import api from "../../helpers/api";
import {setAlert} from "../../store/alerts-slice";
import Loader from "../miscellaneous/Loader/Loader";
import {setPasswordStrength} from "../../store/auth-slice";


const PasswordChange = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const [formSent, setFormSent] = useState(false);
    const [responseError, setResponseError] = useState('');

    const [newPassword, setNewPassword] = useState({value: '', errors: []});
    const [newPasswordAgain, setNewPasswordAgain] = useState({value: '', errors: []});
    const [userPassword, setUserPassword] = useState({value: '', errors: []});


    useEffect(() => {
        if (!props.reset) {
            resetForm();
        }
    }, [props.reset])


    function resetForm() {
        setResponseError('')
        setLoading(false)
        setFormSent(false)      //this will reset all form errors and values
    }

    async function formSentHandler() {
        setFormSent(true)

        //validating:
        let errorCount = newPassword.errors.length + userPassword.errors.length;
        if (newPassword.value !== newPasswordAgain.value) {
            errorCount++;
            setResponseError($t('validation.general.passwordsNoMatch'))
        }
        if (errorCount) {
            return;
        }

        try {
            setLoading(true);
            let res = await api.post('/account/password', {
                clinic_id: props.clinicId,
                userPassword: userPassword.value,
                newPassword: newPassword.value
            })
            setLoading(false);

            if (!res || !res.success || !res.data.success) {
                dispatch(setAlert({type: 'error'}))
                setResponseError(res.errorText)
                return;
            }

            dispatch(setPasswordStrength(1));
            dispatch(setAlert({type: 'success'}))
        } catch (e) {
            console.error(e)
        }
    }


    return (
        <div className={'loaderContainer'}>
            {
                loading ?
                    <div className={'loaderOverlay'}>
                        <Loader/>
                    </div>
                    :
                    null
            }

            <div className={'alma-box-header'}>
                <div>
                    <h3>{$t('global.account.changePassword')}</h3>
                </div>
            </div>
            <div>
                {props.required ?
                <div className={`${styles.responseError} ${styles.padd}`}>
                    {$t('global.login.passwordMustBeChanged')}
                </div>
                :
                null}
            </div>
            <div className={'alma-box-content'} style={{minWidth: '250px'}}>
                <div className={`${styles['fields-row']}`}>
                    <div className={`${styles['field-container']}`}>
                        <div className={`${styles['field-name']}`}>{$t('global.account.currentPassword')}</div>
                        <div className={`${styles['field-input']}`}>
                            <InputWithValidation
                                name="userPassword"
                                // tooltip={$t('global.account.currentPassword')}
                                validations={['required']}
                                onChange={(data) => setUserPassword(data)}
                                touched={formSent}

                                type="password"
                                value={userPassword.value}
                                // placeholder={'userPassword placeholder'}
                            />
                        </div>
                    </div>
                </div>

                <div className={'fields-row'} style={{marginTop: '25px'}}>
                    <div className={'field-container'}>
                        <div className={'field-name'}>{$t('global.account.newPassword')}</div>
                        <div className={'field-input'}>
                            <InputWithValidation
                                name="newPassword"
                                // tooltip={$t('global.account.newPassword')}
                                validations={['required', 'password']}
                                onChange={(data) => setNewPassword(data)}
                                touched={formSent}

                                type="password"
                                value={newPassword.value}
                                // placeholder={'newPassword placeholder'}
                            />
                        </div>
                    </div>
                </div>

                <div className={'fields-row'}>
                    <div className={'field-container'}>
                        <div className={'field-name'}>{$t('global.account.newPasswordAgain')}</div>
                        <div className={'field-input'}>
                            <InputWithValidation
                                name="newPasswordAgain"
                                // tooltip={$t('global.account.newPassword')}
                                validations={['required']}
                                onChange={(data) => setNewPasswordAgain(data)}
                                touched={formSent}

                                type="password"
                                value={newPasswordAgain.value}
                                // placeholder={'newPassword placeholder'}
                            />
                        </div>
                    </div>
                </div>


            </div>

            <div className={'alma-box-footer'}>
                <div></div>
                <div>
                    <div className={'field-container'}>
                        <div className={'alma-button'}
                             onClick={() => formSentHandler()}>{$t('global.account.changePassword')}
                        </div>
                    </div>

                </div>


            </div>
            <div className={styles.responseError}>
                {responseError}
            </div>
        </div>
    )
}


export default PasswordChange;
